import { Button } from '@healingpaper/cell'
import styled from 'styled-components'

import { ResponsiveSizeV2 } from '@/components/atomic/_enums'
import { generateTagId } from '@/utils/test-automation'

export interface BottomBarInfoButtonProps {
  label: string
  ariaLabelOfLabel?: string
  disabled?: boolean
  onClick?: () => void
  id?: string
}

export interface BottomBarInfoButtonsProps {
  'aria-label'?: string
  children?: React.ReactNode
  ariaLabelOfButtonsWrapper?: string
  buttonProps: BottomBarInfoButtonProps[]
}

function BottomBarInfoButtons(props: BottomBarInfoButtonsProps): JSX.Element {
  return (
    <StyledContainer aria-label={props['aria-label']}>
      <StyledHeader $isVisible={!!props.children}>{props.children}</StyledHeader>
      <StyledBody aria-label={props.ariaLabelOfButtonsWrapper}>
        {props.buttonProps.map((buttonProp) => (
          <StyledButton
            id={buttonProp.id || generateTagId('signup', 'bottomSheet', 'btn', 'submit')}
            key={buttonProp.label}
            disabled={buttonProp.disabled}
            onClick={buttonProp.onClick}
            fullWidth={true}
          >
            <StyledLabel aria-label={buttonProp.ariaLabelOfLabel}>{buttonProp.label}</StyledLabel>
          </StyledButton>
        ))}
      </StyledBody>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  position: fixed;
  width: 100%;
  bottom: 0;
  box-shadow: 0px 0px 16px #00000029;
  box-sizing: border-box;
  z-index: 20;
  text-align: center;
  border-radius: 16px 16px 0 0;
  // isDesktop
  @media screen and (min-width: ${ResponsiveSizeV2.MOBILE_MAX_WIDTH}px) {
    max-width: ${ResponsiveSizeV2.MOBILE_WIDTH}px;
  }
`

const StyledHeader = styled.div<{ $isVisible: boolean }>`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 16px 16px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px 4px;
  ${({ $isVisible }) => !$isVisible && 'display: none;'}
`

const StyledBody = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: row;
  padding: 10px 8px;
  gap: 8px;
`

const StyledButton = styled(Button)<{ disabled?: boolean }>`
  flex: 1;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : '')};
  -webkit-tap-highlight-color: transparent;
  height: 60px;

  font-weight: 700;
  font-size: 20px;

  ${({ disabled }) =>
    !disabled &&
    `
      background: linear-gradient(to right, #ff540f, #ff9442);
      color: white;
    `}
`

const StyledLabel = styled.span<{ $disabled?: boolean }>``

export default BottomBarInfoButtons
